var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"eia-progress-bar"},[_c('div',{staticClass:"eia-progress-bar__progress",style:(_vm.style)},[_c('span',[_vm._v(_vm._s(Math.floor( this.progressPercentage, 1 ))+"%")])])])}
var staticRenderFns = []

export { render, staticRenderFns }